import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import React, {useState} from 'react';
import {i18n2} from '../../i18n/i18n';
import {useDeleteProfGral, useLoadProfGral} from '../hooks';
import {profGralSchema} from '../model/ProfGral';
import IntegrityProfGral from './IntegrityProfGral';
import CreateProfGralPopup from './CreateProfGralPopup';
import {IconButton} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import EditProfGralPopup from './EditProfGralPopup';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';
const CustomAddPopup = (open: boolean, setOpen: any, refresh: any) => {
  return (
    <CreateProfGralPopup
      open={open}
      setOpen={setOpen}
      handleClose={() => setOpen(false)}
      refresh={refresh}
    />
  );
};

const MAX_ACTION_BUTTONS = 1;

const Buttons = ({data, refresh}: any) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  if (data.deleted) {
    return null;
  }
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <EditButton row={data} refresh={refresh} />
    </div>
  );
};

const EditButton = ({row, refresh}: any) => {
  const [open, setOpen] = useState(false);
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();

  return (
    <>
      <IconButton
        className={isTablet ? styles.tabletButton : styles.compactButton}
        size="small"
        title="Editar"
        onClick={() => setOpen(true)}>
        <EditIcon
          className={isTablet ? styles.tabletIcon : styles.compactButton}
        />
      </IconButton>
      {open && (
        <EditProfGralPopup
          row={row}
          open={open}
          refresh={refresh}
          handleClose={() => setOpen(false)}
          setOpen={setOpen}
        />
      )}
    </>
  );
};

const ProfGralGrid = () => {
  const loadProfGral = useLoadProfGral();
  const deleteProfGral = useDeleteProfGral();
  const isTablet = useIsTablet();

  return (
    <IntegrityRoleGrid
      allowEdit={Roles.AdminITPS}
      schema={profGralSchema()}
      dataSource={loadProfGral}
      customEditPopup={true}
      componentAddPopup={CustomAddPopup}
      promiseDelete={deleteProfGral}
      id={['iD_ProfGral']}
      allowExport={true}
      columnOptions={columnOptions}
      integrityGrid={IntegrityProfGral}
      integrityId={['ID_ProfGral']}
      integrityName={'ProfGral'}
      exportName="ProfGral-export">
      <Column
        caption=""
        cellComponent={(e) => (
          <Buttons data={e.data.data} refresh={e.data.component.refresh} />
        )}
        fixed
        width={getActionColumnWidth(MAX_ACTION_BUTTONS, isTablet)}
        alignment="right"
      />
      <Column
        caption={i18n2._('Profile-General')}
        defaultSortOrder={'asc'}
        dataField="iD_ProfGral"
      />
      <Column
        caption={i18n2._('Descripcion')}
        dataField="description"
        width={200}
        defaultSortOrder={'asc'}
      />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

const columnOptions = [
  {
    column: 'iD_ProfGral',
    allowEdit: false,
    hiddenAdd: true,
  },
  {
    column: 'Description',
    sizeMobile: 12,
    sizeDesktop: 6,
    required: true,
  },
];

export default ProfGralGrid;
